import { render, staticRenderFns } from "./Registrants.vue?vue&type=template&id=34ce869e&"
import script from "./Registrants.vue?vue&type=script&lang=js&"
export * from "./Registrants.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports